import { AuthLoginSchema, AuthRegisterSchema, User } from '@provaplus/shared';

const RAW_API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';
const API_BASE_URL = RAW_API_URL.endsWith('/api')
  ? RAW_API_URL
  : `${RAW_API_URL.replace(/\/+$/, '')}/api`;

const TOKEN_KEY = 'provaplus_auth_token';
const USER_KEY = 'provaplus_user_data';

export async function login(data: any): Promise<{ user: User, session: { access_token: string } }> {
  AuthLoginSchema.parse(data);
  
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Erro ao realizar login');
  }

  const result = await response.json();
  
  localStorage.setItem(TOKEN_KEY, result.session.access_token);
  localStorage.setItem(USER_KEY, JSON.stringify(result.user));
  
  return result;
}

export async function register(data: any): Promise<{ user: User, session: any }> {
  AuthRegisterSchema.parse(data);

  const response = await fetch(`${API_BASE_URL}/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Erro ao realizar cadastro');
  }

  const result = await response.json();
  
  if (result.session?.access_token) {
    localStorage.setItem(TOKEN_KEY, result.session.access_token);
    localStorage.setItem(USER_KEY, JSON.stringify(result.user));
  }
  
  return result;
}

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredUser(): User | null {
  const userStr = localStorage.getItem(USER_KEY);
  return userStr ? JSON.parse(userStr) : null;
}

export async function getProfile(): Promise<User | null> {
  const token = getStoredToken();
  if (!token) return null;

  const response = await fetch(`${API_BASE_URL}/auth/me`, {
    headers: { 'Authorization': `Bearer ${token}` },
  });

  if (!response.ok) {
    if (response.status === 401) {
      logout();
    }
    return null;
  }

  const user = await response.json();
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  return user;
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
